import React from "react";
import { Button } from "@material-ui/core";
import TextEditor from "@icarius-common/textEditor";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import useHandleForm from "./useHandleForm";

const Form = (props) => {

    const {
        isQuestion,
        data,
        readOnly,
        handleCreate,
        handleUpdate,
        handleClose,
    } = props;

    const dispatch = useDispatch();

    const create = (dataToSend) => {
        handleCreate(dataToSend, () => handleClose());
    }

    const update = (dataToSend) => {
        handleUpdate(dataToSend, () => handleClose());
    }

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    }

    const {
        isCreate,
        setFormValue,
        submit,
    } = useHandleForm(data, create, update, openValidationError);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                gap: 10,
                flex: 1,
                alignItems: "flex-end",
            }}
        >
            <div style={{ width: "100%" }}>
                <TextEditor
                    initialValue={isCreate ? "" : data.content}
                    placeholder={getLocalizedString(isQuestion ? "ask" : "reply")}
                    handleChange={(content, contentHTML) => setFormValue({ content, contentHTML })}
                    disabled={readOnly}
                    allowImages
                />
            </div>
            {
                !readOnly &&
                <div
                    style={{
                        display: "flex",
                        gap: 10,
                    }}
                >
                    {
                        !isCreate &&
                        <Button
                            onClick={handleClose}
                            style={{ border: "1px solid var(--mainText)" }}
                            variant="outlined"
                            className="whiteText"
                        >
                            {getLocalizedString("cancel")}
                        </Button>
                    }
                    <Button
                        onClick={submit}
                        style={{ border: "1px solid var(--mainText)" }}
                        variant="outlined"
                        className="whiteText"
                    >
                        {isCreate ? getLocalizedString("reply") : getLocalizedString("save")}
                    </Button>
                </div>
            }
        </div>
    )
}

export default Form;